import axios from '../api/axios'
import customAxios from 'axios';
import fetchInstance from './fetchConfig';

export default {
    getLst({params, callback}){ // 列表
        axios.post(`/v1/admin/venueAccount/list`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getMasterLst({params, callback}){ // 列表
        let url = `/v1/admin/masterVenue/list?pageNum=${params.pageNum}&pageSize=${params.pageSize}`
        if (params.keyword)
            url += `&keyword=${params.keyword}`
        axios.get(url).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    subVenueList({callback}){ // 查询所有子场馆ID和名称列表
        axios.get(`/v1/admin/masterVenue/subVenueList`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    masterVenue({params, callback}){ // 查询主场馆账号
        axios.get(`/v1/admin/masterVenue/operate/${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    masterVenueDelete({params, callback}){ // 删除主场馆账号
        axios.delete(`/v1/admin/masterVenue/operate/${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    addAnt({params, callback}){ // 新增
        axios.post(`/v1/admin/venueAccount/add?isPro=true`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    getVenueWithParent({hasParent, callback}) { 
        axios.get(`/v1/admin/venueAccount/venues?hasParent=${hasParent}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    addMasAnt({params, callback}){ // 新增
        axios.post(`/v1/admin/masterVenue/operate`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    updateMasAnt({params, callback}){ // 修改
        axios.put(`/v1/admin/masterVenue/operate`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },


    edtAnt({params, callback}){ // 修改
        axios.put(`/v1/admin/venueAccount/update`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    costDis({params, callback}){ // 显示场馆本周预计的成本分配
        axios.post(`/v1/admin/venueAccount/costDistribution`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    weekdeputyRoster({params, callback}){ // 平台端获取每周的员工工作信息列表接口
        axios.post(`/v1/admin/venueAccount/deputyRosterWeekList`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    deputyRoster({params, callback}){ // 获取员工工作信息列表
        axios.post(`/v1/admin/venueAccount/deputyRosterList`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    deputyRosterDetail({params, callback}){ // 获取某一天的所有员工工作信息列表
        axios.post(`/v1/admin/venueAccount/deputyRosterDetails`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    venueAccntDetail({params, callback}){ // 查询场馆端用户信息详情及场馆营业时间
        axios.get(`/v1/admin/venueAccount/details/${params}`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    update({params, callback}){ // 更新场馆端用户禁用状态
        axios.put(`/v1/admin/venueAccount/disable`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    delUser({params, callback}){ // 删除场馆端用户
        axios.delete(`/v1/admin/venueAccount/delete/${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    expense({params, callback}){ // 显示场馆本周预计的成本分配
        axios.post(`/v1/admin/venueAccount/expenseType`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    profit({params, callback}){ // 按时间统计每周的汇总数据
        axios.post(`/v1/admin/venueAccount/profit`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    proLoss({params, cancelToken, callback}){ // 获取收入与支出信息
        axios.post(`/v1/admin/venueAccount/profitLoss`, params, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    weekEndingOfCost({params, cancelToken, callback}){ // 每天平均使用的工资及对应占比
        axios.post(`/v1/admin/venueAccount/weekEndingOfCost`, params, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    weekEndingOfCostList({params, cancelToken, callback}){ // 每周薪资列表
        axios.post(`/v1/admin/venueAccount/weekEndingOfCostList`, params, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    weekEndingOfHours({params, cancelToken, callback}){ // 每天平均使用的工时数及对应占比
        axios.post(`/v1/admin/venueAccount/weekEndingOfHours`, params, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    weekEndingOfHoursList({params, cancelToken, callback}){ // 每周工时列表
        axios.post(`/v1/admin/venueAccount/weekEndingOfHoursList`, params, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    employeeList({params, cancelToken, callback}){ // 获取员工列表
        axios.post(`/v1/admin/venueAccount/employee/list`, params, cancelToken).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    profitLossOfYearList({params, callback}){ // 获取收入与支出信息年份数据
        axios.post(`/v1/admin/venueAccount/profitLossOfYearList`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    profitLossEdit({params, callback}){ //启用-关闭手动编辑profit&loss
        axios.put(`/v1/admin/venueAccount/profitLossEdit`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    activatedLabour({params, callback}){ //启用-关闭手动编辑labour
        axios.put(`/v1/admin/venueAccount/activated-labour`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    venueSetRevenueFrom({params, callback}){
        axios.put(`/v1/admin/venueAccount/venue-set-revenueFrom/${params.venueId}/${params.status}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    signInVenue(params, callback){
        customAxios.post(process.env.VENUE_ENDPOINT_BASE_URL + '/v1/venue/login', params).then(res => {
            callback(res,'login')
        }).catch(err => {
            console.log('err', err);
            callback(err,'login')
        })
    },

    update_app(payload) {
        let url = `/v1/admin/update_app?isPro=${payload.isPro}`

        return axios.put(url, {
            subVenueId: payload.venueId
        })
    },

    activate_manual_journal(payload) {
      let url = `/v1/admin/activate_manual_journal?isManualJournal=${payload.isManualJournal}`
      return axios.put(url, {
         subVenueId: payload.venueId
     })
   },

    activate_cashup(payload) {
        let url = `/v1/admin/activate_cashup?isCashUp=${payload.isCashUp}`
        return axios.put(url, {
            subVenueId: payload.venueId
        })
    },

    activate_cashup_bennelong(payload) {
        let url = `/v1/admin/activate_cashup?isCashUp=${payload.isCashUp}&cashUpFormat=${payload.cashUpFormat}`
        return axios.put(url, {
            subVenueId: payload.venueId
        })
    },

    activate_budgeting(payload) {
        let url = `/v1/admin/activate_budgeting?isBudgeting=${payload.isBudgeting}`
        return axios.put(url, {
            subVenueId: payload.venueId
        })
    },

    activateTargetRevenueForecast(payload) {
        let url = `/v1/admin/activateTargetRevenueForecast?isRevenueTargetForecast=${payload.isRevenueTargetForecastActivated }`
        return axios.put(url, {
            subVenueId: payload.venueId
        })
    },

    activateAccountingPlatform(payload) {
        let url = `/v1/admin/activateAccountingPlatform?isAccountingPlatformActivated=${payload.isAccountingPlatformActivated }`
        return axios.put(url, {
            subVenueId: payload.venueId
        })
    },

    activateEodSplit(payload) {
        let url = `/v1/admin/activateEodSplit?isEodSplit=${payload.isEodSplit}`
        return axios.put(url, {
            subVenueId: payload.venueId
        })
    },

    activateDeputySalary(payload) {
        let url = `/v1/admin/venueAccount/deputy-salary-setting`
        return axios.put(url, {
            venueId: payload.venueId,
            enableDeputySalaryStaff: payload.enableDeputySalaryStaff
        })
    },

    async getTimezoneList(){
        try {
            const res = await fetchInstance(`/api/venue/v1/timezones`)
            return res.json()
        } catch (error) {
            throw new Error("Failed to fetch timezone list");
        }
    },






}



// WEBPACK FOOTER //
// ./src/api/account.js